import { readNestedBookingRecord } from './nestedBookingRecord';

/**
 * Nested `Booking` booked-spot names first, then top-level — matches hydrate / spot-bookings parsing.
 */
export function readRawBookedSpotNamesFromRecord(
  source: Record<string, unknown> | null | undefined
): string[] | string | undefined {
  if (!source) {
    return undefined;
  }
  const nested = readNestedBookingRecord(source);
  if (nested) {
    const nestedNames = nested['booked_spot_names'] ?? nested['bookedSpotNames'];
    if (nestedNames != null) {
      return nestedNames as string[] | string;
    }
  }
  const topLevel = source['booked_spot_names'] ?? source['bookedSpotNames'];
  if (topLevel != null) {
    return topLevel as string[] | string;
  }
  return undefined;
}
